<div *ngIf="notFound" class="container">
  <img src="/assets/images/error.svg" alt="computer" />
  <h2>Oops! There's nothing here.</h2>
  <p>We can't seem to find the page you're looking for.</p>
  <br />
  <p-button (onClick)="navigate()">Back to Platform Home</p-button>
</div>
